import { defineStore } from 'pinia';

export const sessionData = defineStore('session', {
  state: () => ({
    validSession: false,
    intentionalLogout: true,
  }),
  persist: true
});
